import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductName, RenderedOutputSummary } from 'situview-webapi-client';
import { ProductNameService } from 'src/app/services';

@Component({
  selector: 'home-config-list-card',
  templateUrl: './home-config-list-card.component.html',
  styleUrls: ['./home-config-list-card.component.less']
})
export class HomeConfigListCardComponent implements OnInit {
  /* standard */
  @Input() isAdmin: boolean = false;
  @Input() isSituUser: boolean = false;
  @Input() isDarkMode: boolean = false;

  @Input() canView: boolean = false;
  @Input() canCompare: boolean = false;
  @Input() renderedOutput: RenderedOutputSummary | undefined;
  @Input() renderedOutputId: string | undefined;
  @Input() comparisonRenderedOutputId: string | undefined;
  @Input() isSelected: string | undefined;
  @Input() isFailed: boolean = false;

  @Output() selectedRenderedOutputId = new EventEmitter<string>();
  @Output() selectedComparisonRenderedOutputId = new EventEmitter<string>();

  productNames = ProductName;
  imageIcon: string | undefined;
  iconColor: string | undefined;
  productName: string = "";

  constructor(
    private router: Router,
    private productNameService: ProductNameService
  ) {}

  ngOnInit(): void {
    this.iconColor = this.productNameService.getProductNameConfiguration(this.renderedOutput?.productName)?.productColor;
    this.productName = ProductName[this.renderedOutput!.productName!];
    switch (this.renderedOutput?.productName) {
      case ProductName.Facade:
        this.imageIcon = "image";
        break;
      case ProductName.Panorama:
      case ProductName.RayTracedDraft:
      case ProductName.RayTraced:
      case ProductName.RayTracedPlus:
        this.imageIcon = "panorama";
        break;
      case ProductName.Render:
        this.imageIcon = "photo_camera";
        break;
      case ProductName.Plan:
        this.imageIcon = "foundation";
        break;
      case ProductName.VR:
        this.imageIcon = "vrpano";
        break;
      default:
        this.imageIcon = "image";
        break;
    }
  }

  select(renderedOutputId: string) {
    this.selectedRenderedOutputId.emit(renderedOutputId)
  }

  selectForComparison(renderedOutputId: string) {
    this.selectedComparisonRenderedOutputId.emit(renderedOutputId)
  }

  viewRecipeEventSummaryDetail() {
    this.router.navigate(['/admin/recipe-event-summary', this.renderedOutput?.artifactId]);
  }

  isRecent(createTime: Date) {
    let date = new Date();
    date.setMinutes(date.getMinutes() - 15);
    return createTime > date; 
  }
}